import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    imageNumber: 0,
    touboImages: [],
    maxTouboImages: 7,
  },
  mutations: {
    IMAGE_NUMBER (state,n) {
      state.imageNumber = n
    },
    GET_TOUBO(state,file) {
      if( state.touboImages.indexOf(file) == -1 ) {
        state.touboImages.push(file)
      }
    },
  },
})
